import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Inline, contextual follow-up chips rendered under an assistant message.
 * Each chip's `prompt` is sent verbatim as the next user message when clicked.
 */
export const SuggestedActions = ({ actions = [], onPick, disabled }) => {
  if (!actions?.length) return null;
  return (
    <div data-testid="ai-agent-suggested-actions" className="mt-3 not-prose">
      <div className="mb-1 flex items-center gap-1 text-[10px] uppercase tracking-wide text-slate-500">
        <Sparkles className="h-3 w-3" />
        <span>Try next</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {actions.map((a, i) => (
          <button
            key={`${a.label}_${i}`}
            disabled={disabled}
            onClick={() => onPick?.(a.prompt)}
            data-testid="ai-agent-suggested-action-chip"
            className="rounded-full border border-teal-200 bg-teal-50 px-2.5 py-1 text-[11px] font-medium text-teal-800 hover:border-teal-400 hover:bg-teal-100 disabled:opacity-40"
          >
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedActions;
